import React from 'react';
import {
  Tabs,
  Tab,
  Box,
  Button,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Card
} from '@mui/material';
import Client from '../Client';
import Config from '../ClientConfig';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { locationsList } from './simpleBiReportsApi';

function formatIref(iref) {
  const irefStr = String(iref);
  const zerosNeeded = 7 - irefStr.length;
  const zeros = '0'.repeat(zerosNeeded > 0 ? zerosNeeded : 0);

  return 'K' + zeros + irefStr;
}

class PurchaseReceiptUI extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client("none"),
      tabIndex: 0,
      isSubmitting: false,
      purchaseOrders: [],
      productEntries: [],

      orderData: {
        type: '',
        documentDate: '',
        promisedDate: '',
        location: '',
        description: '',
        supplier: '',
        PurchaseOrderProductEntry_po: []
      },

      psiData: {
        productSupplierInfo: []
      },

      selectedSupplier: '',
      tabs: ['NIR List', 'New NIR'],

      selectedOrder: null,
      showDetailDialog: false,

      selectedSupplierFilter: 0,
      selectedLocationFilter: 0,

      location: 0,
      locations: [{ iref: 0, name: "Select Location" }],

      supplier: 0,
      suppliers: [{ iref: 0, name: "Select Supplier" }]
    };

    this.getData = this.getData.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.fetchPurchaseOrders = this.fetchPurchaseOrders.bind(this);
  }

  componentDidMount() {
    this.fetchPurchaseOrders();
    this.getData();
  }

  fetchPurchaseOrders = (locationId = null, supplierId = null) => {
    const queryData = {
      type: 1,
    };

    if (locationId && Number(locationId) !== 0) {
      queryData.location = locationId;
    }

    if (supplierId && Number(supplierId) !== 0) {
      queryData.supplier = supplierId;
    }

    let data = this.state.client.getData(Config.API_URL_PURCHASE_ORDERS, queryData);

    if (data) {
      let checks = [];

      if (Array.isArray(data)) {
        checks = data;
      } else if (Array.isArray(data.purchaseOrder)) {
        checks = data.purchaseOrder;
      } else if (data.purchaseOrder) {
        checks = [data.purchaseOrder];
      }

      this.setState({ purchaseOrders: checks });
    }
  };

  getData() {
    let psiData = this.state.client.getData(Config.API_URL_PRODUCT_SUPPLIER_INFO, { active: 1 });

    if (psiData) {
      this.setState({ psiData: psiData });
    }

    let queryData = {
      status: 2,
      isPurchased: 1,
      orderBy_name: 1,
    };

    let data = this.state.client.getData(Config.API_URL_PRODUCT, queryData);

    if (data && psiData) {
      const fullProductsMap = {};

      if (Array.isArray(data.products)) {
        data.products.forEach(product => {
          fullProductsMap[product.iref] = product;
        });
      }

      const quantityMultiplierMap = {};

      if (Array.isArray(psiData.productSupplierInfo)) {
        psiData.productSupplierInfo.forEach(info => {
          if (info.preferred) {
            quantityMultiplierMap[info.product.iref] = info.quantityMultiplier;
          }
        });
      }

      const products = Array.isArray(data.products)
        ? data.products.filter(p => p.centralSupply === 0)
        : [];

      const productEntries = Object.keys(products).map((key) => {
        const fData = products[key];

        return {
          productId: fData.iref,
          productName: fData.name,
          unit: fData.unitType,
          inputQuantity: '',
          quantity: '',
          reactKey: `${fData.iref}-${key}`,
          quantityMultiplier: quantityMultiplierMap[fData.iref] ?? 1
        };
      });

      this.setState({
        fullProductsMap,
        products,
        productEntries
      });
    } else {
      alert('Failed to load products.');
    }

    let locations = locationsList(this.state.client);

    if (locations && Array.isArray(locations.locations)) {
      this.setState({ locations: locations.locations });
    }
  }

  handleLocationFilterChange = (e) => {
    const locationId = e.target.value;

    this.setState({ selectedLocationFilter: locationId }, () => {
      this.fetchPurchaseOrders(
        this.state.selectedLocationFilter,
        this.state.selectedSupplierFilter
      );
    });
  };

  handleSupplierFilterChange = (e) => {
    const supplierId = e.target.value;

    this.setState({ selectedSupplierFilter: supplierId }, () => {
      this.fetchPurchaseOrders(
        this.state.selectedLocationFilter,
        this.state.selectedSupplierFilter
      );
    });
  };

  selectLocation = (event) => {
    this.setState(
      { location: event.target.value },
      function () {
        this.handleOrderChange('location', event.target.value);
      }
    );
  }

  selectSupplier = (event) => {
    const supplierIref = event.target.value;

    this.setState(
      { selectedSupplier: supplierIref },
      () => {
        this.handleSupplierChange(supplierIref);
      }
    );
  };

  handleSupplierChange = (supplierIref) => {
    const filteredProducts = (this.state.psiData.productSupplierInfo || [])
      .filter(item => {
        return (
          String(item.supplier?.iref) === String(supplierIref) &&
          (item.centralSupply === false || item.centralSupply === 0)
        );
      })
      .map(item => {
        const product = item.product;

        return {
          productId: product.iref,
          productName: product.name,
          unit: product.unitType ?? 0,
          quantityMultiplier: item.quantityMultiplier || 1,
          inputQuantity: '',
          quantity: ''
        };
      })
      .sort((a, b) => a.productName.localeCompare(b.productName));

    this.setState({ productEntries: filteredProducts });
  };

  handleChange = (event, newValue) => {
    this.setState({ tabIndex: newValue });
  };

  handleOrderChange = (field, value) => {
    this.setState(prev => ({
      orderData: {
        ...prev.orderData,
        [field]: value,
      },
    }));
  };

  handleQuantityChange = (index, value) => {
    const productEntries = [...this.state.productEntries];
    const entry = productEntries[index];
    const v = String(value);

    if (v === '' || v === '-' || /[.,]$/.test(v)) {
      entry.quantity = v;
    } else {
      if (Number(entry.unit) === 1) {
        entry.quantity = v.replace(',', '.');
      } else {
        const n = parseFloat(v.replace(',', '.'));
        entry.quantity = isNaN(n) ? 0 : n;
      }
    }

    this.setState({ productEntries });
  }

  handleSubmit = () => {
    if (this.state.isSubmitting) return;

    const { orderData, productEntries, selectedSupplier } = this.state;

    if (!orderData.promisedDate || !orderData.location) {
      alert('Please fill in both Date and Location before submitting.');
      return;
    }

    const filteredProducts = productEntries
      .filter(p => p.quantity && !isNaN(p.quantity) && parseFloat(p.quantity) !== 0)
      .map(p => ({
        product: p.productId,
        unit: p.unit,
        quantity: parseFloat(p.quantity)
      }));

    if (filteredProducts.length === 0) {
      alert("Please enter at least one product line with quantity > 0.");
      return;
    }

    const now = new Date();
    const createdOn = now.toISOString();
    const type = 1;
    const supplier = selectedSupplier;

    const payload = {
      ...orderData,
      type,
      supplier,
      createdOn,
      PurchaseOrderProductEntry_po: filteredProducts
    };

    const result = this.state.client.pushData(Config.API_URL_PURCHASE_ORDERS, payload);

    if (result) {
      if (result && result.iref) {
        alert("NIR saved!");

        this.setState(prev => ({
          orderData: {
            type: 0,
            promisedDate: '',
            location: '',
            supplier: 0,
            description: ''
          },
          productEntries: prev.productEntries.map(p => ({
            ...p,
            quantity: '',
            inputQuantity: ''
          })),
          location: 0,
          tabIndex: 0,
          isSubmitting: false
        }));

        this.fetchPurchaseOrders();
      } else {
        console.error('Save failed', result);

        const errorMessage = result.responseJSON?.message || "Save failed.";

        this.setState({ isSubmitting: false });
        alert(errorMessage);
      }
    } else {
      alert("Save failed: no response from server.");
    }
  };

  openOrderDetail = (po) => {
    this.setState({
      selectedOrder: po,
      showDetailDialog: true
    });
  };

  closeOrderDetail = () => {
    this.setState({
      showDetailDialog: false,
      selectedOrder: null
    });
  };

  getLocations() {
    let locations = [{ iref: 0, name: "Select Location" }];

    if (this.state.locations) {
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];

        if (fData && fData.iref !== undefined) {
          let myData = { iref: fData.iref, name: fData.name };
          locations.push(myData);
        }
      });
    }

    return locations;
  }

  getSuppliers() {
    const localSuppliers = Object.values(
      (this.state.psiData?.productSupplierInfo || [])
        .filter(item => item.centralSupply === false)
        .reduce((acc, item) => {
          const id = item.supplier?.iref;

          if (id && !acc[id]) {
            acc[id] = item.supplier;
          }

          return acc;
        }, {})
    );

    return [{ iref: 0, name: "Select Supplier" }, ...localSuppliers];
  }

  renderNewOrderForm = () => {
    const { orderData, productEntries } = this.state;

    let locations = this.getLocations();
    let suppliers = this.getSuppliers();

    const unitTypeMap = { 0: 'pc', 1: 'kg' };

    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    const minDateObj = new Date(today);
    minDateObj.setDate(minDateObj.getDate() - 30);

    const yyyyMin = minDateObj.getFullYear();
    const mmMin = String(minDateObj.getMonth() + 1).padStart(2, '0');
    const ddMin = String(minDateObj.getDate()).padStart(2, '0');
    const minDate = `${yyyyMin}-${mmMin}-${ddMin}`;

    const maxDate = `${yyyy}-${mm}-${dd}`;

    const { productSupplierInfo = [] } = this.state.psiData;
    const { products = [] } = this.state;

    const supplierProductIds = new Set(
      productSupplierInfo
        .filter(psi => String(psi.supplier?.iref) === String(this.state.selectedSupplier))
        .map(psi => psi.product.iref)
    );

    const filteredProducts = products.filter(product => supplierProductIds.has(product.iref));

    return (
      <Box
        sx={{
          height: "100%",
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr 1fr",
              sm: "180px 220px 160px auto"
            },
            gap: {
              xs: 1,
              sm: 1.25
            },
            alignItems: "end",
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <TextField
            id="standard-select-location"
            select
            required
            value={orderData.location || 0}
            variant="standard"
            size="small"
            sx={this.filterSx()}
            onChange={this.selectLocation}
          >
            {locations.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            variant="standard"
            required
            value={this.state.selectedSupplier || 0}
            onChange={this.selectSupplier}
            size="small"
            sx={this.filterSx()}
          >
            {suppliers.map((supplier) => (
              <MenuItem key={supplier.iref} value={supplier.iref}>
                {supplier.name}
              </MenuItem>
            ))}
          </TextField>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Date"
              value={orderData.promisedDate ? dayjs(orderData.promisedDate) : null}
              onChange={(newValue) => {
                const formattedDate = newValue ? newValue.format('YYYY-MM-DD') : '';

                this.setState(prev => ({
                  orderData: {
                    ...prev.orderData,
                    documentDate: formattedDate,
                    promisedDate: formattedDate,
                  }
                }));
              }}
              minDate={dayjs(minDate)}
              maxDate={dayjs(maxDate)}
              inputFormat="DD.MM.YYYY"
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  size="small"
                  sx={this.filterSx()}
                  InputLabelProps={{ shrink: true }}
                />
              )}
              required
            />
          </LocalizationProvider>

          <Box sx={{ display: { xs: "none", sm: "block" } }} />
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0
          }}
        >
          <TableContainer
            sx={{
              height: "100%",
              overflow: "auto"
            }}
          >
            <Table stickyHeader size="small" aria-label="new nir table">
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx("left", null, true)}>
                    <b>Product</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("center", 48, true)}>
                    <b>Unit</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("right", 116, true)}>
                    <b>Quantity</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {productEntries
                  .filter(entry => supplierProductIds.has(entry.productId))
                  .map((entry, index) => (
                    <TableRow key={entry.reactKey || entry.productId}>
                      <TableCell sx={this.bodyCellSx("left", false, null, true)}>
                        {entry.productName}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("center", false, 48, true)}>
                        {unitTypeMap[entry.unit]}
                      </TableCell>

                      <TableCell sx={this.bodyCellSx("right", false, 116, true)}>
                        <TextField
                          type="text"
                          inputMode="text"
                          value={String(entry.quantity ?? '')}
                          onKeyDown={(e) => {
                            if (e.key === '-' || e.key === 'Minus' || e.key === 'Subtract') {
                              e.preventDefault();

                              const cur = String(entry.quantity ?? '').replace(',', '.');

                              if (cur === '' || cur === '-') {
                                this.handleQuantityChange(index, '-');
                              } else if (cur.startsWith('-')) {
                                this.handleQuantityChange(index, cur.slice(1));
                              } else {
                                this.handleQuantityChange(index, '-' + cur);
                              }
                            }
                          }}
                          onChange={(e) => {
                            const raw = e.target.value;

                            if (Number(entry.unit) === 1) {
                              if (/^-?\d*(?:[.,]\d{0,3})?$/.test(raw)) {
                                this.handleQuantityChange(index, raw.replace(',', '.'));
                              }
                            } else {
                              if (/^-?\d*$/.test(raw)) {
                                this.handleQuantityChange(index, raw);
                              }
                            }
                          }}
                          onBlur={(e) => {
                            let v = e.target.value.replace(',', '.');

                            if (v === '' || v === '-') return this.handleQuantityChange(index, '');
                            if (Number.isNaN(Number(v))) return;

                            if (Number(entry.unit) === 1) {
                              const m = v.match(/^(-?\d+)(?:[.,](\d{0,3}))?$/);

                              if (m) {
                                const intPart = m[1];
                                const decPart = m[2] ?? '';
                                const out = decPart ? `${intPart}.${decPart}` : intPart;
                                this.handleQuantityChange(index, out);
                              }
                            } else {
                              const n = parseInt(v, 10);

                              if (!isNaN(n)) this.handleQuantityChange(index, String(n));
                            }
                          }}
                          inputProps={{
                            step: entry.unit === 1 ? '0.001' : '1',
                            style: { textAlign: 'right' },
                            pattern: Number(entry.unit) === 1
                              ? "^-?[0-9]+([.,][0-9]{0,3})?$"
                              : "^-?[0-9]+$",
                          }}
                          InputProps={{
                            sx: {
                              py: 0.2,
                              height: '34px',
                              width: {
                                xs: '78px',
                                sm: '110px'
                              },
                              fontSize: {
                                xs: '16px',
                                sm: '14px'
                              },
                              backgroundColor: entry.unit === 1 ? '#e6f7ff' : 'inherit',
                            },
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 1,
              sm: 1.25
            },
            borderTop: "1px solid rgba(0,0,0,0.08)",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Button
            variant="contained"
            color="primary"
            sx={{
              minWidth: {
                xs: "100%",
                sm: 220
              },
              px: 3
            }}
            onClick={this.handleSubmit}
            disabled={this.state.isSubmitting}
          >
            Save NIR
          </Button>
        </Box>
      </Box>
    );
  };

  renderOrderList = () => {
    let locations = this.getLocations();
    let suppliers = this.getSuppliers();

    return (
      <Box
        sx={{
          height: "100%",
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            px: {
              xs: 1,
              sm: 1.5
            },
            py: {
              xs: 0.75,
              sm: 1
            },
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr 1fr",
              sm: "220px 260px auto"
            },
            gap: {
              xs: 1,
              sm: 1.25
            },
            alignItems: "end",
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <TextField
            id="standard-select-location-filter"
            select
            required
            value={this.state.selectedLocationFilter || 0}
            variant="standard"
            size="small"
            sx={this.filterSx()}
            onChange={this.handleLocationFilterChange}
          >
            {locations.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            variant="standard"
            required
            value={this.state.selectedSupplierFilter || 0}
            onChange={this.handleSupplierFilterChange}
            size="small"
            sx={this.filterSx()}
          >
            {suppliers.map((supplier) => (
              <MenuItem key={supplier.iref} value={supplier.iref}>
                {supplier.name}
              </MenuItem>
            ))}
          </TextField>

          <Box sx={{ display: { xs: "none", sm: "block" } }} />
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0
          }}
        >
          <TableContainer
            sx={{
              height: "100%",
              overflow: "auto"
            }}
          >
            <Table stickyHeader size="small" aria-label="nir list table">
              <TableHead>
                <TableRow>
                  <TableCell sx={this.headerCellSx("center", 82)}>
                    <b>NIR</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left", 105)}>
                    <b>Date</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left")}>
                    <b>Location</b>
                  </TableCell>

                  <TableCell sx={this.headerCellSx("left")}>
                    <b>Supplier</b>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {(this.state.purchaseOrders || []).map((po, idx) => (
                  <TableRow
                    key={idx}
                    hover
                    onClick={() => this.openOrderDetail(po)}
                    sx={{ cursor: 'pointer' }}
                  >
                    <TableCell sx={this.bodyCellSx("center", false, 82)}>
                      {formatIref(po.iref)}
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("left", false, 105)}>
                      {po.documentDate}
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("left")}>
                      {po.location?.name || po.location?.uid || '-'}
                    </TableCell>

                    <TableCell sx={this.bodyCellSx("left")}>
                      {po.supplier?.name || '-'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    );
  };

  renderOrderDetailDialog = () => {
    const { selectedOrder } = this.state;

    if (!selectedOrder) return null;

    const unitTypeMap = { 0: 'pc', 1: 'kg' };

    return (
      <Dialog
        open={this.state.showDetailDialog}
        onClose={this.closeOrderDetail}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            m: 0,
            p: {
              xs: 1.5,
              sm: 2
            },
            pr: 7,
            fontSize: {
              xs: "15px",
              sm: "18px"
            },
            fontWeight: 700
          }}
        >
          NIR Detail - {formatIref(selectedOrder.iref)}

          <IconButton
            aria-label="close"
            onClick={this.closeOrderDetail}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            px: {
              xs: 1.5,
              sm: 2
            }
          }}
        >
          <Typography sx={this.dialogInfoSx()}>
            Date: {selectedOrder.documentDate}
          </Typography>

          <Typography sx={this.dialogInfoSx()}>
            NIR: {formatIref(selectedOrder.iref)}
          </Typography>

          <Typography sx={this.dialogInfoSx()}>
            Location: {selectedOrder.location?.name || '-'}
          </Typography>

          <Typography sx={this.dialogInfoSx()}>
            Supplier: {selectedOrder.supplier?.name || '-'}
          </Typography>

          {selectedOrder.PurchaseOrderProductEntry_po?.length > 0 && (
            <Box mt={2}>
              <TableContainer
                sx={{
                  maxHeight: {
                    xs: "65vh",
                    sm: "70vh"
                  },
                  overflow: "auto"
                }}
              >
                <Table stickyHeader size="small" aria-label="nir detail table">
                  <TableHead>
                    <TableRow>
                      <TableCell sx={this.headerCellSx("left")}>
                        <b>Product</b>
                      </TableCell>

                      <TableCell sx={this.headerCellSx("center", 48)}>
                        <b>Unit</b>
                      </TableCell>

                      <TableCell sx={this.headerCellSx("right", 90)}>
                        <b>Quantity</b>
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {[...selectedOrder.PurchaseOrderProductEntry_po]
                      .sort((a, b) => {
                        const nameA = this.state.fullProductsMap?.[a.product.iref]?.name || '';
                        const nameB = this.state.fullProductsMap?.[b.product.iref]?.name || '';

                        return nameA.localeCompare(nameB);
                      })
                      .map((line, idx) => {
                        const product = this.state.fullProductsMap?.[line.product.iref] || {};

                        return (
                          <TableRow key={idx}>
                            <TableCell sx={this.bodyCellSx("left", false)}>
                              {product.name || line.product.iref || '-'}
                            </TableCell>

                            <TableCell sx={this.bodyCellSx("center", false, 48)}>
                              {unitTypeMap[product.unitType] || '-'}
                            </TableCell>

                            <TableCell sx={this.bodyCellSx("right", false, 90)}>
                              {line.quantity.toLocaleString()}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    );
  };

  render() {
    const { tabIndex, tabs } = this.state;

    return (
      <Card
        sx={{
          borderRadius: "14px",
          overflow: "hidden",
          maxWidth: "100%",
          height: {
            xs: "calc(100vh - 92px)",
            md: "calc(100vh - 104px)"
          },
          minHeight: {
            xs: 500,
            sm: 540
          },
          display: "flex",
          flexDirection: "column"
        }}
      >
        <Box
          sx={{
            background: "#f6f4ef",
            borderBottom: "1px solid rgba(0,0,0,0.08)"
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              minHeight: {
                xs: 40,
                sm: 42
              },
              px: {
                xs: 0.25,
                sm: 0.5
              },
              "& .MuiTab-root": {
                minHeight: {
                  xs: 42,
                  sm: 44
                },
                minWidth: "auto",
                textTransform: "none",
                fontSize: {
                  xs: "13px",
                  sm: "14px"
                },
                fontWeight: 700,
                px: {
                  xs: 1.3,
                  sm: 1.8
                }
              }
            }}
          >
            {tabs.map((label, idx) => (
              <Tab key={idx} label={label} />
            ))}
          </Tabs>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0
          }}
        >
          {tabIndex === 0 ? this.renderOrderList() : this.renderNewOrderForm()}
        </Box>

        {this.renderOrderDetailDialog()}
      </Card>
    );
  }

  filterSx() {
    return {
      width: "100%",
      minWidth: 0,
      "& .MuiInputBase-input": {
        fontSize: {
          xs: "16px",
          sm: "14px"
        }
      },
      "& .MuiInputLabel-root": {
        fontSize: {
          xs: "13px",
          sm: "13px"
        }
      }
    };
  }

  dialogInfoSx() {
    return {
      fontSize: {
        xs: "13.5px",
        sm: "14px"
      },
      mb: 0.25
    };
  }

  headerCellSx(align, minWidth = null, compact = false) {
    return {
      padding: compact
        ? {
            xs: "8px 3px",
            sm: "7px 5px"
          }
        : {
            xs: "8px 7px",
            sm: "7px"
          },
      textAlign: align,
      whiteSpace: "nowrap",
      minWidth: minWidth,
      fontSize: {
        xs: "13px",
        sm: "13px",
        md: "14px"
      },
      backgroundColor: "#f6f4ef"
    };
  }

  bodyCellSx(align, strong = false, minWidth = null, compact = false) {
    return {
      padding: compact
        ? {
            xs: "8px 3px",
            sm: "7px 5px"
          }
        : {
            xs: "8px 7px",
            sm: "7px"
          },
      textAlign: align,
      whiteSpace: align === "left" ? "normal" : "nowrap",
      minWidth: minWidth,
      fontSize: {
        xs: "13.5px",
        sm: "13px",
        md: "14px"
      },
      fontWeight: strong ? 600 : 400,
      lineHeight: 1.35
    };
  }
}

export default PurchaseReceiptUI;
